const kpis = [
  { metric: 'Конверсия в продажу', icon: 'ri-percent-line', desc: 'Процент встреч/звонков, завершившихся сделкой' },
  { metric: 'Средний чек', icon: 'ri-money-dollar-circle-line', desc: 'Средняя сумма одной сделки' },
  { metric: 'Длина сделки', icon: 'ri-time-line', desc: 'Время от первого контакта до закрытия' },
  { metric: 'Скорость обработки заявок', icon: 'ri-flashlight-line', desc: 'Время реакции на входящий запрос' },
  { metric: 'Повторные продажи', icon: 'ri-refresh-line', desc: 'Доля клиентов, вернувшихся за повторной покупкой' },
  { metric: 'Удержание клиентов (Retention)', icon: 'ri-shield-user-line', desc: 'Процент клиентов, продолжающих сотрудничество' },
  { metric: 'NPS (Net Promoter Score)', icon: 'ri-star-line', desc: 'Индекс готовности клиентов рекомендовать компанию' },
  { metric: 'CSI (Customer Satisfaction)', icon: 'ri-emotion-happy-line', desc: 'Индекс удовлетворённости клиентов' },
  { metric: 'Количество ошибок / брака', icon: 'ri-error-warning-line', desc: 'Число рекламаций, возвратов, неточностей' },
  { metric: 'Текучесть персонала', icon: 'ri-user-unfollow-line', desc: 'Процент сотрудников, покинувших компанию за период' },
  { metric: 'Скорость адаптации новичков', icon: 'ri-user-add-line', desc: 'Время от найма до выхода на плановые KPI' },
  { metric: 'Выполнение KPI / плана', icon: 'ri-bar-chart-2-line', desc: 'Процент сотрудников, выполняющих плановые показатели' },
];

export default function KPITable() {
  return (
    <section id="kpi" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие KPI действительно показывают эффективность обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Для каждой метрики нужны два замера: до начала обучения и через 1-3 месяца после. Разница между ними — это реальный эффект от обучения, выраженный в цифрах.
        </p>

        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
          <div className="bg-teal-600 px-6 md:px-8 py-5">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-1 text-white font-bold text-sm">#</div>
              <div className="col-span-4 text-white font-bold text-sm">Показатель KPI</div>
              <div className="col-span-3 text-white font-bold text-sm text-center">До обучения</div>
              <div className="col-span-3 text-white font-bold text-sm text-center">После обучения</div>
              <div className="col-span-1"></div>
            </div>
          </div>
          <div className="divide-y divide-gray-100">
            {kpis.map((k, i) => (
              <div key={i} className="grid grid-cols-12 gap-4 px-6 md:px-8 py-4 items-center hover:bg-gray-50/50 transition-colors">
                <div className="col-span-1 text-sm text-gray-400 font-medium">{i + 1}</div>
                <div className="col-span-4 flex items-center gap-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${k.icon} text-sm text-teal-600`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{k.metric}</div>
                    <div className="text-xs text-gray-500">{k.desc}</div>
                  </div>
                </div>
                <div className="col-span-3 text-center">
                  <div className="text-sm text-gray-400">Замер №1</div>
                  <div className="text-sm text-gray-500 italic">базовый уровень</div>
                </div>
                <div className="col-span-3 text-center">
                  <div className="text-sm text-teal-700 font-bold">Замер №2</div>
                  <div className="text-xs text-teal-600">через 1-3 мес.</div>
                </div>
                <div className="col-span-1 flex justify-center">
                  <i className="ri-arrow-right-line text-teal-600 text-lg"></i>
                </div>
              </div>
            ))}
          </div>
          <div className="bg-teal-50 px-6 md:px-8 py-5 text-center">
            <p className="text-teal-800 font-bold">
              Разница между замерами по каждой метрике — это измеримый эффект от обучения
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}